/**
 * Convert from scale from 0 to 100 to MIN_SLIDER_VALUE to MAX_SLIDER_VALUE
 * @usage `val / (MAX_SLIDER_VALUE-MIN_SLIDER_VALUE) = x / (100-0)`
 */
export const scaledRangeChartValues = (val: number, bounds: { min: number; max: number }) =>
  ((val - bounds.min) / (bounds.max - bounds.min)) * 100;
